<!-- TODO возможно понадобится еще блокирующий все -->
<!-- <app-loader></app-loader> -->
<div id="layout-topbar" *ngIf="!isWidgetMode">
  <div class="content">
    <app-header></app-header>
  </div>
  <div class="layout-progress-bar">
    <ng-container *ngIf="state$ | async as state">
      <div class="layout-progress-bar-fill" *ngIf="state.isLoading" [style.width.%]="loaderService.progress"></div>
    </ng-container>
  </div>
</div>
<div id="layout-filterbar" *ngIf="appSettings.currentUrlPath === '' && !isWidgetMode">
  <div class="content grid white-space-nowrap p-0">
    <ng-container *ngIf="appSettings.selectedRacesType.value !== 'race_changes'">
      <app-date [showDate]="showDate" class="flex col-6">
      </app-date>
      <div class="flex col-1">
        <p-button [icon]="showMap ? 'pi pi-list' : 'pi pi-map'" (onClick)="onMap()" [pTooltip]="
            showMap ? appSettings.translate[appSettings.selectedLang]['map_off'] : appSettings.translate[appSettings.selectedLang]['map_on']
          "></p-button>
      </div>
    </ng-container>
    <ng-container *ngIf="appSettings.selectedRacesType.value === 'race_changes'">
      <div class="col-7"></div>
    </ng-container>
    <app-type-race [ngClass]="{
        'col-4': authService.user && authService.user.isOrg,
        'col-5': !authService.user || !authService.user.isOrg
      }" [hidden]="!authService.user" (typeChange)="onRaceFilterChange($event)"></app-type-race>
    <div class="col-1" [hidden]="!authService.user || !(authService.user.isOrg || authService.user.admin)">
      <div class="flex align-items-end justify-content-end">
        <p-button icon="pi pi-plus" class="add-button" (onClick)="goToCreateRace()"
          [pTooltip]="appSettings.translate[appSettings.selectedLang]['create_race']"></p-button>
      </div>
    </div>
  </div>
</div>
<div id="layout-content" [ngClass]="{
    'second-page': appSettings.currentUrlPath !== '',
    'main-page': appSettings.currentUrlPath === ''
  }">
  <div class="content"
    [ngClass]="{ 'full-content': appSettings.currentUrlData.includes('progress') || appSettings.currentUrlData.includes('map') }">
    <router-outlet></router-outlet>
  </div>
</div>

<!-- Диалог подтверждения -->
<p-confirmDialog #cd header="Подтвердите действие" icon="pi pi-exclamation-triangle">
  <p-footer>
    <button type="button" pButton icon="pi pi-check" label="Да" (click)="cd.accept()"></button>
    <button type="button" pButton icon="pi pi-times" label="Нет" (click)="cd.reject()"></button>
  </p-footer>
</p-confirmDialog>

<!-- Вывод сообщений -->
<p-toast position="top-right"></p-toast>